import { Tooltip, Center } from '@chakra-ui/react'
import { Lock } from 'components/icons'

type DotParams = {
  color?: string
  label?: string
  size?: number
}

export default function Dot({ color = 'danger', label, size = 4 }: DotParams) {
  return (
    <Tooltip bg={color} label={label}>
      <Center>
        <Lock color={color} boxSize={size} />
      </Center>
    </Tooltip>
  )
}
